export const REGISTER_EMPLOYEE_ABSENCE = 'register-employee-absence';
